import React from 'react';
import HeaderDrawer from "../../common/components/HeaderDrawer";
import Logs from '../components/Logs';

const LogsScreen = (props) => {
  return (
    <HeaderDrawer name="Logs">
      <Logs {...props} />
    </HeaderDrawer>
  );
}

export default LogsScreen;